module.exports = __webpack_public_path__ + "img/icon-frown.551320f3.svg";